import {StyleSheet} from 'react-native';

export default StyleSheet.create({
    container: {
        flex: 1,
    },
    shareTitle:{
        fontFamily: 'Raleway',
        marginBottom: 4,
        marginTop:20,
        fontSize: 14,
        fontWeight: '600'
    },
    shareBody:{
        fontFamily: 'Raleway',
        fontWeight:'400',
        color:'#999999',
    },
    text: {
        marginLeft:15,
        fontFamily: 'Raleway'
    },
    socialContainer: {
        flexDirection:'row',
        marginTop:10
    },
    socialIcon: {
        marginRight:5
    },
    img:{width:300,height:300,alignSelf:'center'},
});
